import { Guid } from "@/types"
import Notification, { IGetNotification, NotificationType } from "./Notification"

export interface IGetNotificationAutomaticInvoicingFailedDto extends IGetNotification {
    notificationType: NotificationType.automaticInvoicingFailed
    reservationId: Guid
    reservationNumber: string
    number: string
}

export default class NotificationAutomaticInvoicingFailed extends Notification {
    reservationId: Guid
    reservationNumber: string
    number: string

    constructor(dto: IGetNotificationAutomaticInvoicingFailedDto) {
        super(dto)
        this.reservationId = dto.reservationId
        this.reservationNumber = dto.reservationNumber
        this.number = dto.number
    }
}
